module.exports = __webpack_public_path__ + "assets/lessons/en/audio/Audio 1.pdf";